// src/components/leadsComponents/LeadRow.js
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import LeadStatusBadge from './LeadStatusBadge';

export default function LeadRow({ lead, onClick }) {
  // compute “Last Contact” text
 // Find the most recent message timestamp (inbound or outbound)
  const lastMsg = (lead.messages || [])
    .map(m => new Date(m.timestamp))
    .sort((a, b) => b - a)[0];
  const lastContact = lastMsg
    ? formatDistanceToNow(lastMsg, { addSuffix: true })
    : 'Never';

  // pull estimated property count
  const propCount = lead.enrichment?.property_count_estimate ?? 0;

return (
  <div
    onClick={onClick}
    className="
      bg-white hover:bg-[#F9FAFB] transition-shadow duration-200
      p-5 rounded-[20px] shadow-[0_2px_6px_rgba(0,0,0,0.04)]
      border border-[#E5E7EB] cursor-pointer mb-4
    "
  >
    {/* Top: Company and Badge */}
    <div className="flex justify-between items-start">
      <div className="flex-1 min-w-0">
        <p className="text-lg font-semibold text-[#111827] truncate">
          {lead.company_name || '—'}
        </p>
        <p className="text-sm text-[#6B7280] truncate mt-0.5">
          {lead.emails?.[0]?.address || '—'}
        </p>
      </div>
      <div className="ml-4 flex-shrink-0">
        <LeadStatusBadge status={lead?.status || 'new'} />
      </div>
    </div>

    {/* Bottom: Grid details */}
    <div className="mt-4 grid grid-cols-3 gap-4 text-sm text-[#374151]">
      <div className="space-y-0.5">
        <p className="text-[11px] font-semibold text-[#6B7280] uppercase tracking-wide">Owner</p>
        <p className="truncate">{lead.owner_name || '—'}</p>
      </div>
      <div className="space-y-0.5">
        <p className="text-[11px] font-semibold text-[#6B7280] uppercase tracking-wide">Properties</p>
        <p>{propCount ?? '—'}</p>
      </div>
      <div className="space-y-0.5">
        <p className="text-[11px] font-semibold text-[#6B7280] uppercase tracking-wide">Last Contact</p>
        <p className="truncate">{lastContact || '—'}</p>
      </div>
    </div>
  </div>
);

}
